class SetsugekkaConsent extends HTMLElement {
  connectedCallback() {
    this.checkbox = this.querySelector('[data-purchase-consent]');
    this.buttons = this.querySelector('[data-consent-buttons]');
    this.timestamp = this.querySelector('[data-consent-time]');
    if (!this.checkbox || !this.buttons || !this.timestamp) return;
    this.checkbox.checked = false;
    this.sync = () => {
      const agreed = this.checkbox.checked;
      this.buttons.disabled = !agreed;
      this.buttons.inert = !agreed;
      this.timestamp.disabled = !agreed;
      this.timestamp.value = agreed ? new Date().toISOString() : '';
    };
    this.checkbox.addEventListener('change', this.sync);
    this.reset = () => { this.checkbox.checked = false; this.sync(); };
    window.addEventListener('pageshow', this.reset);
    this.sync();
  }
  disconnectedCallback() {
    this.checkbox?.removeEventListener('change', this.sync);
    window.removeEventListener('pageshow', this.reset);
  }
}
if (!customElements.get('setsugekka-consent')) customElements.define('setsugekka-consent', SetsugekkaConsent);
document.addEventListener('submit', (event) => {
  const checkbox = event.target.querySelector?.('[data-purchase-consent]');
  if (checkbox && !checkbox.checked) {
    event.preventDefault();
    event.stopImmediatePropagation();
    checkbox.reportValidity();
    checkbox.focus();
  }
}, true);
